/**
 * DatabaseControllers are used to encapsulate database actions and can in some cases be seen as implementations of the
 * decorator pattern ( https://wiki.python.org/moin/DecoratorPattern ). In other cases it's just encapsulation.
 */
import ObjectID from "bson-objectid";
import {isValidId} from "../basic";
import DataController from "../datastructures/DataController";
import {ID_EXCEPTION} from "../exceptions";

export interface IDatabaseController extends DataController {
    getId(): ObjectID;
    getSid(): string;
    setId(_id: ObjectID): void;
}

export default class DatabaseController extends DataController implements IDatabaseController {

    @DataController.dataProperty()
    private _id: ObjectID;

    constructor(id: ObjectID | string) {
        super();
        this.setId(id);
    }

    public getId(): ObjectID {
        return this._id;
    }

    public getSid(): string {
        return this._id.toHexString();
    }

    public setId(id: any): void {
        if(!isValidId(id)) {
            throw ID_EXCEPTION;
        }
        this._id = new ObjectID(id);
    }

}
